import React from "react";
import "./style.scss";

interface IProps {
  title: string;
  children: any;
  className?: string;
}

const PanelCustom: React.FC<IProps> = ({ title, children, className }: IProps) => {
  return (
    <div className={`panel-custom ${className}`}>
      {title && <p className={"title"}>{title}</p>}
      {children}
    </div>
  );
};

export default PanelCustom;
